// import { CiMenuBurger } from "react-icons/ci";
// import { NavLink } from "react-router-dom";

import "./toolbar.css";

const Toolbar = () => {
  return (
     <div>
        <nav className="toolbar_wrapper">
            <div>logo</div>
            <div className="toolbar_div_wrapper">
                <ul className="toolbar_ul_container">
                    <li><a href="#about_me" className="toolbar_li">About Me</a></li>
                    <li><a href="#skills" className="toolbar_li">skills</a></li>
                    <li><a href="#projects" className="toolbar_li">project</a></li>
                    {/* <NavLink to="/#about_me" className="toolbar_li"><li>About Me</li></NavLink> */}
                    {/* <NavLink to="#skills" className="toolbar_li"><li>Skills</li></NavLink> */}
                    {/* <NavLink to="#projects" className="toolbar_li"><li>Projects</li></NavLink> */}
                    {/* <NavLink to="/contact" className="toolbar_li"><li>Contact</li></NavLink> */}
                </ul>
            </div>
        </nav>
     </div>
  );
};

export default Toolbar;
